import React from 'react';
import { ErrorListProps } from '@rjsf/utils';


const CustomErrorList = ({ errors }: ErrorListProps) => (
  <div className="panel panel-danger errors">
    <div className="panel-heading">
      <h3 className="panel-title">エラー</h3>
    </div>
    <ul className="list-group">
      {errors.map((error, i) => (
        <li key={i} className="list-group-item text-danger">{error.stack}</li>
      ))}
    </ul>
  </div>
);

export default CustomErrorList;
